"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullSignUp = exports.SignUp = void 0;
var SignUp_1 = require("./SignUp");
Object.defineProperty(exports, "SignUp", { enumerable: true, get: function () { return __importDefault(SignUp_1).default; } });
var Full_1 = require("./Full");
Object.defineProperty(exports, "FullSignUp", { enumerable: true, get: function () { return __importDefault(Full_1).default; } });
